/**
 * Header portals grid catalog
 *
 * Declarative description of the apps launcher grid opened from the header
 * "Abrir aplicações" button (Figma `1235:9011` — "Menu Grid Portais").
 *
 * Each tile points at the **home** page of a portal and reuses the shared
 * navigation constants, so no new URL contract is introduced here.
 *
 * @module home-v2/constants/portals
 * @category Constants
 */

import { PDT_LINKS, PORTAL_ID_LINKS } from '@/features/home-v2/constants/links';
import type { PortalMenuItem } from '@/features/home-v2/types/portals';

import ManageSearchIcon from '@/assets/icons/home-v2/portal-manage-search.svg?react';
import DevicesIcon from '@/assets/icons/home-v2/portal-devices.svg?react';
import ArrowSplitDisabledIcon from '@/assets/icons/home-v2/portal-arrow-split-disabled.svg?react';

/** Size of the glyph inside every portal tile badge (Figma `icon`). */
export const PORTAL_ICON_SIZE = 24;

/**
 * Portals of the header apps grid, in Figma order.
 *
 * - `pdt` → Plataforma Data Trust home (node `1235:9014`)
 * - `portal-id` → Portal de Identidade de Fraude home (node `1235:9018`)
 * - `idwall` → Portal idwall (node `1235:9022`), inert until it is integrated
 */
export const PORTAL_MENU_ITEMS: readonly PortalMenuItem[] = [
  {
    key: 'pdt',
    labelKey: 'Data Trust Platform',
    Icon: ManageSearchIcon,
    url: PDT_LINKS.HOME,
    platform: 'pdt',
  },
  {
    key: 'portal-id',
    labelKey: 'Fraud Identity Portal',
    Icon: DevicesIcon,
    url: PORTAL_ID_LINKS.HOME,
    platform: 'portalId',
  },
  {
    key: 'idwall',
    labelKey: 'idwall Portal',
    // Disabled glyph + "EM BREVE" badge, like the idwall column of the new home
    // (the Figma grid still shows it enabled — outdated, only the layout applies).
    Icon: ArrowSplitDisabledIcon,
  },
] as const;
